import { useState, FC } from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";
import {
  CollectionIndexContext,
  CollectionIndexContextValue,
  CollectionIndexProviderProps,
} from "./";

/* ===========================================================================
 * PROVIDER: CollectionIndexProvider
 * =========================================================================== */

/**
 * @component CollectionIndexProvider
 *
 * Manages the top-level state for the Collection Index page.
 * Primarily handles modal configuration (opening/closing modals for create,
 * edit, or delete actions) and provides a shared callback for UI refreshing.
 *
 * @param {CollectionIndexProviderProps} props - Provider properties including the main action callback.
 * @returns {JSX.Element} A React Context Provider for index-level state.
 */
export const CollectionIndexProvider: FC<CollectionIndexProviderProps> = ({
  children,
  callback,
}) => {
  /** Modal configuration state to control visibility and content of page modals. */
  const [modalConfig, setModalConfig] = useState<ModalConfig>(
    createModalConfig()
  );

  /* ---------------------------------------------------------------------------
   * CONTEXT VALUE & RENDER
   * ------------------------------------------------------------------------- */

  const contextValue: CollectionIndexContextValue = {
    modalConfig,
    callback,
    setModalConfig,
  };

  return (
    <CollectionIndexContext.Provider value={contextValue}>
      {children}
    </CollectionIndexContext.Provider>
  );
};
